import { Colors } from "components/common/Colors";
import Icon from "components/Icons/Icon";

const UspItem = ({ text, color = Colors.main1 }) => {
  return (
    <li className="usp-item">
      <Icon name="checkStamp" fill={Colors?.[color]} />
      <p>{text}</p>
    </li>
  );
};

export default UspItem;
